import { useSelector } from "react-redux";
import { REDUCER_KEY_BROKER } from "../../reduxV2/broker";
import * as brokerSelectors2 from "../../reduxV2/broker/broker.selectors";
import { EAccountRole, EUserFeature } from "../../types/auth.types";
import { REDUCER_KEY_CONTACT } from "../contact/contact.reducer";
import { getContactMe, getContactMeMaster } from "../contact/contact.selectors";
import { REDUCER_KEY_AUTH } from "./auth.reducer";
import * as authSelectors from "./auth.selectors";
export var useSelf = function () {
    var _a;
    var user = useSelector(authSelectors.getUser);
    var contactMe = useSelector(function (state) { return getContactMe(state); });
    var contactMeMaster = useSelector(function (state) {
        return getContactMeMaster(state);
    });
    var broker = useSelector(function (state) {
        return brokerSelectors2.getDetail(state, user === null || user === void 0 ? void 0 : user.brokerId);
    });
    var isBroker = !!(user === null || user === void 0 ? void 0 : user.brokerId);
    var isMonitor = ((_a = user === null || user === void 0 ? void 0 : user.features) === null || _a === void 0 ? void 0 : _a.includes(EUserFeature.Monitor)) || false;
    return {
        user: user,
        contactMe: contactMe,
        contactMeMaster: contactMeMaster,
        broker: broker,
        isBroker: isBroker,
        isMonitor: isMonitor,
    };
};
export var useIsOfficeAdmin = function () {
    var _a, _b, _c, _d;
    var user = useSelector(authSelectors.getUser);
    var isMonitor = (_b = (_a = user === null || user === void 0 ? void 0 : user.features) === null || _a === void 0 ? void 0 : _a.includes(EUserFeature.Monitor)) !== null && _b !== void 0 ? _b : false;
    return (isMonitor ||
        ((_d = (_c = user === null || user === void 0 ? void 0 : user.accountRoles) === null || _c === void 0 ? void 0 : _c.includes(EAccountRole.OfficeAdmin)) !== null && _d !== void 0 ? _d : false));
};
